/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molarity & Mass Molarity Calculator`)
};

const es_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridad y Masa Molar`)
};

const de_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molaritäts- und Massenmolaritätsrechner`)
};

const nl_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molariteit- en massamolariteitcalculator`)
};

const fr_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de molarité et de masse molaire`)
};

const it_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di molarità e massa molare`)
};

const pt_br2_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridade e Massa Molar`)
};

const pt_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridade e Massa Molar`)
};

const ja_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル濃度・質量モル濃度計算ツール`)
};

const zh_massmol_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔浓度与质量摩尔浓度计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_h1", locale)
	if (locale === "en") return en_massmol_h1(inputs)
	if (locale === "es") return es_massmol_h1(inputs)
	if (locale === "de") return de_massmol_h1(inputs)
	if (locale === "nl") return nl_massmol_h1(inputs)
	if (locale === "fr") return fr_massmol_h1(inputs)
	if (locale === "it") return it_massmol_h1(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_h1(inputs)
	if (locale === "pt") return pt_massmol_h1(inputs)
	if (locale === "ja") return ja_massmol_h1(inputs)
	return zh_massmol_h1(inputs)
};